(function (factory) {
	var moduleName = "interactiveStudio";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName, ["jquery"], factory);
		return;
	}

	var moduleExport = factory(window.ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {
	window.CcsInteractiveStudio = (function () {
		var defaults = {
			iframeId: "from server",
			domain: "https://xbox-interactive.com",
			prefix: "xis",
			state: "_XisState",
			textPrefix: "Xbox",
			eventMessageHeightUpdated: "Xis height updated",
			eventMessageStateUpdated: "Xis state updated"
		};

		function initialize(options) {
			! function (t, options) {
				var n = {};
			
				function e(r) {
					if (n[r]) return n[r].exports;
					var o = n[r] = {
						i: r,
						l: !1,
						exports: {}
					};
					return t[r].call(o.exports, o, o.exports, e, options), o.l = !0, o.exports
				}
				e.m = t, e.c = n, e.d = function (t, n, r) {
					e.o(t, n) || Object.defineProperty(t, n, {
						enumerable: !0,
						get: r
					})
				}, e.r = function (t) {
					"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
						value: "Module"
					}), Object.defineProperty(t, "__esModule", {
						value: !0
					})
				}, e.t = function (t, n) {
					if (1 & n && (t = e(t)), 8 & n) return t;
					if (4 & n && "object" == typeof t && t && t.__esModule) return t;
					var r = Object.create(null);
					if (e.r(r), Object.defineProperty(r, "default", {
						enumerable: !0,
						value: t
					}), 2 & n && "string" != typeof t)
						for (var o in t) e.d(r, o, function (n) {
							return t[n]
						}.bind(null, o));
					return r
				}, e.n = function (t) {
					var n = t && t.__esModule ? function () {
						return t.default
					} : function () {
						return t
					};
					return e.d(n, "a", n), n
				}, e.o = function (t, n) {
					return Object.prototype.hasOwnProperty.call(t, n)
				}, e.p = "", e(e.s = 31)
			}([function (t, n) {
				var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
				"number" == typeof __g && (__g = e)
			}, function (t, n) {
				t.exports = function (t) {
					return "object" == typeof t ? null !== t : "function" == typeof t
				}
			}, function (t, n) {
				var e = t.exports = {
					version: "2.6.11"
				};
				"number" == typeof __e && (__e = e)
			}, function (t, n, e) {
				t.exports = !e(6)((function () {
					return 7 != Object.defineProperty({}, "a", {
						get: function () {
							return 7
						}
					}).a
				}))
			}, function (t, n, e) {
				"use strict";
				var r = e(10),
					o = e(23),
					i = e(25),
					c = "".endsWith;
				r(r.P + r.F * e(29)("endsWith"), "String", {
					endsWith: function (t) {
						var n = i(this, t, "endsWith"),
							e = arguments.length > 1 ? arguments[1] : void 0,
							r = o(n.length),
							u = void 0 === e ? r : Math.min(o(e), r),
							a = String(t);
						return c ? c.call(n, a, u) : n.slice(u - a.length, u) === a
					}
				})
			}, function (t, n, e) {
				var r = e(11),
					o = e(16);
				t.exports = e(3) ? function (t, n, e) {
					return r.f(t, n, o(1, e))
				} : function (t, n, e) {
					return t[n] = e, t
				}
			}, function (t, n) {
				t.exports = function (t) {
					try {
						return !!t()
					} catch (t) {
						return !0
					}
				}
			}, function (t, n) {
				var e = 0,
					r = Math.random();
				t.exports = function (t) {
					return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + r).toString(36))
				}
			}, function (t, n, e) {
				var r = e(2),
					o = e(0),
					i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
				(t.exports = function (t, n) {
					return i[t] || (i[t] = void 0 !== n ? n : {})
				})("versions", []).push({
					version: r.version,
					mode: e(20) ? "pure" : "global",
					copyright: "В© 2019 Denis Pushkarev (zloirock.ru)"
				})
			}, function (t, n, e) {
				var r = e(8)("wks"),
					o = e(7),
					i = e(0).Symbol,
					c = "function" == typeof i;
				(t.exports = function (t) {
					return r[t] || (r[t] = c && i[t] || (c ? i : o)("Symbol." + t))
				}).store = r
			}, function (t, n, e) {
				var r = e(0),
					o = e(2),
					i = e(5),
					c = e(17),
					u = e(21),
					a = function (t, n, e) {
						var f, s, l, p, d = t & a.F,
							v = t & a.G,
							y = t & a.S,
							h = t & a.P,
							m = t & a.B,
							g = v ? r : y ? r[n] || (r[n] = {}) : (r[n] || {}).prototype,
							b = v ? o : o[n] || (o[n] = {}),
							x = b.prototype || (b.prototype = {});
						for (f in v && (e = n), e) l = ((s = !d && g && void 0 !== g[f]) ? g : e)[f], p = m && s ? u(l, r) : h && "function" == typeof l ? u(Function.call, l) : l, g && c(g, f, l, t & a.U), b[f] != l && i(b, f, p), h && x[f] != l && (x[f] = l)
					};
				r.core = o, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a
			}, function (t, n, e) {
				var r = e(12),
					o = e(13),
					i = e(15),
					c = Object.defineProperty;
				n.f = e(3) ? Object.defineProperty : function (t, n, e) {
					if (r(t), n = i(n, !0), r(e), o) try {
						return c(t, n, e)
					} catch (t) { }
					if ("get" in e || "set" in e) throw TypeError("Accessors not supported!");
					return "value" in e && (t[n] = e.value), t
				}
			}, function (t, n, e) {
				var r = e(1);
				t.exports = function (t) {
					if (!r(t)) throw TypeError(t + " is not an object!");
					return t
				}
			}, function (t, n, e) {
				t.exports = !e(3) && !e(6)((function () {
					return 7 != Object.defineProperty(e(14)("div"), "a", {
						get: function () {
							return 7
						}
					}).a
				}))
			}, function (t, n, e) {
				var r = e(1),
					o = e(0).document,
					i = r(o) && r(o.createElement);
				t.exports = function (t) {
					return i ? o.createElement(t) : {}
				}
			}, function (t, n, e) {
				var r = e(1);
				t.exports = function (t, n) {
					if (!r(t)) return t;
					var e, o;
					if (n && "function" == typeof (e = t.toString) && !r(o = e.call(t))) return o;
					if ("function" == typeof (e = t.valueOf) && !r(o = e.call(t))) return o;
					if (!n && "function" == typeof (e = t.toString) && !r(o = e.call(t))) return o;
					throw TypeError("Can't convert object to primitive value")
				}
			}, function (t, n) {
				t.exports = function (t, n) {
					return {
						enumerable: !(1 & t),
						configurable: !(2 & t),
						writable: !(4 & t),
						value: n
					}
				}
			}, function (t, n, e) {
				var r = e(0),
					o = e(5),
					i = e(18),
					c = e(7)("src"),
					u = e(19),
					a = ("" + u).split("toString");
				e(2).inspectSource = function (t) {
					return u.call(t)
				}, (t.exports = function (t, n, e, u) {
					var f = "function" == typeof e;
					f && (i(e, "name") || o(e, "name", n)), t[n] !== e && (f && (i(e, c) || o(e, c, t[n] ? "" + t[n] : a.join(String(n)))), t === r ? t[n] = e : u ? t[n] ? t[n] = e : o(t, n, e) : (delete t[n], o(t, n, e)))
				})(Function.prototype, "toString", (function () {
					return "function" == typeof this && this[c] || u.call(this)
				}))
			}, function (t, n) {
				var e = {}.hasOwnProperty;
				t.exports = function (t, n) {
					return e.call(t, n)
				}
			}, function (t, n, e) {
				t.exports = e(8)("native-function-to-string", Function.toString)
			}, function (t, n) {
				t.exports = !1
			}, function (t, n, e) {
				var r = e(22);
				t.exports = function (t, n, e) {
					if (r(t), void 0 === n) return t;
					switch (e) {
						case 1:
							return function (e) {
								return t.call(n, e)
							};
						case 2:
							return function (e, r) {
								return t.call(n, e, r)
							};
						case 3:
							return function (e, r, o) {
								return t.call(n, e, r, o)
							}
					}
					return function () {
						return t.apply(n, arguments)
					}
				}
			}, function (t, n) {
				t.exports = function (t) {
					if ("function" != typeof t) throw TypeError(t + " is not a function!");
					return t
				}
			}, function (t, n, e) {
				var r = e(24),
					o = Math.min;
				t.exports = function (t) {
					return t > 0 ? o(r(t), 9007199254740991) : 0
				}
			}, function (t, n) {
				var e = Math.ceil,
					r = Math.floor;
				t.exports = function (t) {
					return isNaN(t = +t) ? 0 : (t > 0 ? r : e)(t)
				}
			}, function (t, n, e) {
				var r = e(26),
					o = e(28);
				t.exports = function (t, n, e) {
					if (r(n)) throw TypeError("String#" + e + " doesn't accept regex!");
					return String(o(t))
				}
			}, function (t, n, e) {
				var r = e(1),
					o = e(27),
					i = e(9)("match");
				t.exports = function (t) {
					var n;
					return r(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t))
				}
			}, function (t, n) {
				var e = {}.toString;
				t.exports = function (t) {
					return e.call(t).slice(8, -1)
				}
			}, function (t, n) {
				t.exports = function (t) {
					if (null == t) throw TypeError("Can't call method on  " + t);
					return t
				}
			}, function (t, n, e) {
				var r = e(9)("match");
				t.exports = function (t) {
					var n = /./;
					try {
						"/./"[t](n)
					} catch (e) {
						try {
							return n[r] = !1, !"/./"[t](n)
						} catch (t) { }
					}
					return !0
				}
			}, , function (t, n, e, options) {
				"use strict";
				e.r(n);
				var r = {
					IFRAME_ID: options.iframeId,
					IFRAME_HEIGHT_SCRIPT: "iframe-height.min.js",
					IFRAME_HEIGHT_LEGACY_SCRIPT: "iframe-height-legacy.js",
					IFRAME_HEIGHT_LEGACY_DOMAINS: [options.domain],
					IFRAME_TEXT_PREFIX: options.textPrefix,
					IFRAME_EVENT_MESSAGE_HEIGHT_UPDATED: options.eventMessageHeightUpdated,
					IFRAME_EVENT_MESSAGE_STATE_UPDATED: options.eventMessageStateUpdated
				},
					o = "".concat("iframe-scroll/", options.prefix + "-iframe-scroll.js"),
					i = "".concat("iframe-scroll/", "io-polyfill.js"),
					c = "".concat("iframe-scroll/", "smoothscroll.js"),
					u = options.prefix + "-iframe-scroll",
					a = o,
					f = i,
					s = c,
					l = options.state,
					p = function (t, n) {
						var e = document.getElementsByTagName("script")[0],
							r = document.createElement("script");
						r.defer = !0, r.async = n || !1, r.src = t, e.parentNode.insertBefore(r, e)
					};
				e(4);
			
				function d(t, n) {
					var e;
					if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
						if (Array.isArray(t) || (e = function (t, n) {
							if (!t) return;
							if ("string" == typeof t) return v(t, n);
							var e = Object.prototype.toString.call(t).slice(8, -1);
							"Object" === e && t.constructor && (e = t.constructor.name);
							if ("Map" === e || "Set" === e) return Array.from(t);
							if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return v(t, n)
						}(t)) || n && t && "number" == typeof t.length) {
							e && (t = e);
							var r = 0,
								o = function () { };
							return {
								s: o,
								n: function () {
									return r >= t.length ? {
										done: !0
									} : {
											done: !1,
											value: t[r++]
										}
								},
								e: function (t) {
									throw t
								},
								f: o
							}
						}
						throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
					}
					var i, c = !0,
						u = !1;
					return {
						s: function () {
							e = t[Symbol.iterator]()
						},
						n: function () {
							var t = e.next();
							return c = t.done, t
						},
						e: function (t) {
							u = !0, i = t
						},
						f: function () {
							try {
								c || null == e.return || e.return()
							} finally {
								if (u) throw i
							}
						}
					}
				}
			
				function v(t, n) {
					(null == n || n > t.length) && (n = t.length);
					for (var e = 0, r = new Array(n); e < n; e++) r[e] = t[e];
					return r
				}
				var y = function () {
					var t = document.getElementById(r.IFRAME_ID);
					if (!t) throw new Error(r.IFRAME_TEXT_PREFIX + " Iframe could not be found");
					var n = t.getAttribute("src");
					if (!n) throw new Error(r.IFRAME_TEXT_PREFIX + " Iframe does not have a source");
					var e = n.split("/")[0] + "//" + n.split("/")[2],
						o = document.querySelector('script[src*="'.concat(r.IFRAME_HEIGHT_SCRIPT, '"]')),
						i = o ? o.src.replace(r.IFRAME_HEIGHT_SCRIPT, "") : void 0;
					if (i || console.warn(r.IFRAME_TEXT_PREFIX + " iframe height script could not detect its own source."), i && !i.endsWith("/") && (i += "/"), i) {
						var c, v = d(r.IFRAME_HEIGHT_LEGACY_DOMAINS);
						try {
							for (v.s(); !(c = v.n()).done;) {
								var y = c.value;
								if (e === y) return void p(i + r.IFRAME_HEIGHT_SCRIPT_LEGACY)
							}
						} catch (t) {
							v.e(t)
						} finally {
							v.f()
						}
					}
					window.addEventListener("resize", (function () {
						g()
					})), window.addEventListener("message", (function (event) {
						var senderWindow = t.contentWindow || t.contentDocument.defaultView;
						if (senderWindow === event.source) {
							if (event.origin === e) return r.IFRAME_EVENT_MESSAGE_HEIGHT_UPDATED === event.data.msg ? h(event.data.content) : r.IFRAME_EVENT_MESSAGE_STATE_UPDATED === event.data.msg ? m(event.data.content) : "URL Request" === event.data.msg ? g({
								msg: "URL Response",
								url: window.location.href
							}) : void 0
						}
					}), !1);
					var h = function (n) {
						if (n === 0) {
							t.style.height = "430px"
						} else {
							t.style.height = n + "px"
						}
					},
						m = function (t) {
							window[l] || b(), window[l] = t
						},
						g = function (n) {
							t.contentWindow.postMessage(n || "", e)
						},
						b = function () {
							if (i) {
								var t = !("IntersectionObserver" in window) && !("IntersectionObserverEntry" in window),
									n = !("scrollBehavior" in document.documentElement.style),
									e = document.createElement("div");
								e.id = u, document.body.appendChild(e), t && p(i + f), n && p(i + s), p(i + a)
							} else console.error("\n        " + r.IFRAME_TEXT_PREFIX + " iframe height script tried to initialise the scrolling embed but wasn't able to.\n        It relies on being able to detect its own source.\n      ")
						}
				};
				y();
				n.default = y
			}], options);
		}

		function interactiveStudio(options) {
			this.options = $.extend(true, {}, defaults, options);
			initialize.call(this, this.options);
		}

		return interactiveStudio;
	}());
}));